
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import PopoverMenu from "@/components/PopoverMenu";
import UpdateMultipleItems from "../components/UpdateMultipleItems";
import SimpleModal from "@/components/Dialogs/SimpleModal";
import TempStarsTableTitle from "@/components/shared/TempStarsTableTitle";
import TruncatedTextCell from "@/components/shared/TruncatedTextCell";
import EntityIdLink from "@/components/shared/EntityIdLink";
import { formatNotes } from "@/helpers";
import { headersInterface } from "@/interfaces/Tables.interfaces";
import { constants } from "@/utils/constants";
import { startCase } from "lodash";
import { updateHourlyRate } from "@/api";
import {
  BOOLEAN_LABELS,
  formatAdminEnum,
  formatCentralBooking,
  formatInvoicePaidStatus
} from "@/helpers/adminEnumLabels";

interface Item {
  id: number;
  jobId: number;
  column: string;
  value: number;
}

export default Vue.extend({
  name: "Invoice",
  components: {
    UpdateMultipleItems,
    PopoverMenu,
    SimpleModal,
    TempStarsTableTitle,
    TruncatedTextCell,
    EntityIdLink
  },
  data: () => {
    return {
      tableSearch: "",
      modalHeader: "",
      showModal: false,
      currentItem: {} as Item,
      hourlyRateDialog: false,
      currentHourlyRate: 0
    };
  },
  computed: {
    ...mapState({
      tablename: "tablename",
      headers: "tableHeaders",
      content: "tableContent",
      preSaveData: "preparedDataToSave"
    }),
    tableHeaders(): Array<headersInterface> {
      const tableColumns = constants.enabledColumns.invoiceTable;
      const data = tableColumns.map(i => {
        return { align: "left", text: startCase(i), value: i };
      });
      return data;
    }
  },
  methods: {
    ...mapMutations(["modify", "modifyMultiple", "callSnackbar"]),
    formatCentralBooking,
    formatInvoicePaidStatus,
    formatBooleanStatus(value: number | string | boolean | null | undefined): string {
      return formatAdminEnum(BOOLEAN_LABELS, value);
    },
    formatResolutionTimestamp(value: string | null | undefined): string {
      return value ? String(value) : "—";
    },
    findHeaderIndex(name: string): number {
      return this.headers.findIndex(item => item.value === name);
    },
    async modalSubmit() {
      const changedData = this.currentItem.value === 0 ? 1 : 0;
      const data = this.content.map((item: any) => {
        if (item.id === this.currentItem.id) {
          item[this.currentItem.column] = changedData;
        }
        return item;
      });

      this.modifyMultiple([
        {
          property: "preparedDataToSave",
          value: [
            ...this.preSaveData,
            {
              tablename: this.tablename,
              column: this.currentItem.column,
              columnId: this.currentItem.id,
              prevValue: this.currentItem.value,
              value: changedData
            }
          ]
        },
        { property: "tableContent", value: data }
      ]);

      this.showModal = false;
    },
    changePaid(id: number, column: string, value: number) {
      this.currentItem = { id, column, value, jobId: 0 };
      this.modalHeader =
        value === 0
          ? "Do you want to change this to PAID?"
          : "Do you want to change this to UNPAID?";

      this.showModal = true;
    },
    formatNotes(note: string | null) {
      return formatNotes(note);
    },
    async changeHourlyRate() {
      try {
        await updateHourlyRate(this.currentItem.jobId, this.currentHourlyRate);

        this.hourlyRateDialog = false;

        this.callSnackbar({
          visible: true,
          text: "Data updated",
          color: "green darken-2"
        });
      } catch (error) {
        this.callSnackbar({
          visible: true,
          text: "Data not updated",
          color: "red darken-2"
        });
      } finally {
        await this.$store.dispatch("getData", { tablename: "Invoice" });
      }
    }
  }
});
